export default "__VITE_ASSET__CzeU13L4__"